import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=9b66ba80&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=9b66ba80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b66ba80",
  null
  
)

export default component.exports